export default __webpack_public_path__ + "static/layout-example-sideNav-light-5ae165c5f8aa75d916cf8bdf5958141b06beb3327de3cc266f1c2911aecc39db.png";